<template>
    <div>
        <certificate-data-view :college-id="$store.state.userInfo.userId" class="my-3"></certificate-data-view>
    </div>
</template>

<script>
import CertificateDataView from "@/components/study/CertificateDataView";
export default {
    name: "CollegeCertificateDataManage",
    components: {CertificateDataView},
    data: function () {
        return {};
    },
    mounted() {

    },
    methods: {}
}
</script>

<style scoped>

</style>